import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const ActionCenterWidget = () => {
  const navigate = useNavigate();
  const handleReview = type => {
    // Logic to handle review based on type
    console.log(`Reviewing ${type}`);
  };
  return (
    <>
      <Card>
        <Card.Header>
          <h5 className="text-lg font-medium leading-6 text-gray-900">
            Action Center
          </h5>
        </Card.Header>
        <Card.Body>
          <Button style={{ width: '100%' }} variant="primary">
            <i className="fas fa-play mr-2 mx-2"></i>
            Run Payroll
          </Button>
          <Button
            style={{ width: '100%' }}
            variant="success"
            className="mt-2"
            onClick={() => navigate('/social/directory/user-details')}
          >
            <i className="fas fa-user-plus mr-2 mx-2"></i>
            Add New Employee
          </Button>

          <Button
            style={{ backgroundColor: '#6f42c1', width: '100%' }}
            className="mt-2"
          >
            <i className="fas fa-chart-bar mr-2 mx-2"></i>
            Generate Reports
          </Button>
          <Button
            style={{
              backgroundColor: '#EBB30B',
              borderColor: '#EBB30B',
              width: '100%'
            }}
            className="mt-2"
          >
            <i className="fas fa-calculator mr-2 mx-2"></i>
            Tax Calculations
          </Button>
          <Card>
            <Card.Header>
              <h6 className="text-lg font-medium leading-6 text-gray-900 m-0">
                Pending Approvals
              </h6>
            </Card.Header>
            <Card.Body>
              <ul
                style={{
                  maxHeight: '200px',
                  overflowY: 'auto',
                  listStyleType: 'none',
                  padding: 0
                }}
              >
                <li
                  style={{
                    fontSize: '12px',
                    borderBottom: '1px solid #E5E7EB',
                    padding: '8px 0'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span
                        style={{
                          backgroundColor: '#FEE2E2',
                          padding: '6px',
                          borderRadius: '4px',
                          display: 'flex', // make the span a flex container
                          alignItems: 'center', // center the icon
                          justifyContent: 'center'
                        }}
                      >
                        <i
                          className="fas fa-exclamation-circle text-red-600"
                          style={{ fontSize: '14px', color: '#DC2627' }}
                        ></i>
                      </span>
                      <p style={{ margin: 0 }}>Overtime approval (3)</p>
                    </div>
                    <Button
                      onClick={() => handleReview('overtime')}
                      className="btn-sm text-sm text-blue-600 hover:text-blue-500 !rounded-button whitespace-nowrap cursor-pointer"
                    >
                      Review
                    </Button>
                  </div>
                </li>
                <li
                  style={{
                    fontSize: '12px',
                    borderBottom: '1px solid #E5E7EB',
                    padding: '8px 0'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span
                        style={{
                          backgroundColor: '#FEF9C3',
                          padding: '6px',
                          borderRadius: '4px',
                          display: 'flex', // make the span a flex container
                          alignItems: 'center', // center the icon
                          justifyContent: 'center'
                        }}
                      >
                        <i
                          className="fas fa-clock text-red-600"
                          style={{ fontSize: '14px', color: '#CB8A04' }}
                        ></i>
                      </span>
                      <p
                        className="ml-2 text-sm font-medium text-gray-900"
                        style={{ margin: 0 }}
                      >
                        Time sheets pending (5)
                      </p>
                    </div>
                    <Button
                      onClick={() => handleReview('overtime')}
                      className="btn-sm text-sm text-blue-600 hover:text-blue-500 !rounded-button whitespace-nowrap cursor-pointer"
                    >
                      Review
                    </Button>
                  </div>
                </li>
                <li
                  style={{
                    fontSize: '12px',
                    borderBottom: '1px solid #E5E7EB',
                    padding: '8px 0'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span
                        style={{
                          backgroundColor: '#DBEAFE',
                          padding: '6px',
                          borderRadius: '4px',
                          display: 'flex', // make the span a flex container
                          alignItems: 'center', // center the icon
                          justifyContent: 'center'
                        }}
                      >
                        <i
                          className="fas fa-file-alt text-red-600"
                          style={{ fontSize: '14px', color: '#2563EB' }}
                        ></i>
                      </span>
                      <p
                        className="ml-2 text-sm font-medium text-gray-900"
                        style={{ margin: 0 }}
                      >
                        New expense claims (2)
                      </p>
                    </div>
                    <Button
                      onClick={() => handleReview('overtime')}
                      className="btn-sm text-sm text-blue-600 hover:text-blue-500 !rounded-button whitespace-nowrap cursor-pointer"
                    >
                      Review
                    </Button>
                  </div>
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
    </>
  );
};
export default ActionCenterWidget;
